import { render } from "./InvestmentRussia.vue?vue&type=template&id=3d44dafc"
import script from "./InvestmentRussia.vue?vue&type=script&lang=js"
export * from "./InvestmentRussia.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__